"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverPosition = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _utils = require("../utils");
var _div;
const PopoverPosition = exports.PopoverPosition = {
  Center: 'center',
  BottomCenter: 'bottom-center',
  BottomRight: 'bottom-right',
  BottomLeft: 'bottom-left',
  TopCenter: 'top-center',
  TopRight: 'top-right',
  TopLeft: 'top-left',
  LeftTop: 'left-top',
  LeftBottom: 'left-bottom',
  LeftCenter: 'left-center',
  RightTop: 'right-top',
  RightBottom: 'right-bottom',
  RightCenter: 'right-center',
  InsideBottomCenter: 'inside-bottom-center',
  InsideBottomRight: 'inside-bottom-right',
  InsideBottomLeft: 'inside-bottom-left',
  InsideTopCenter: 'inside-top-center',
  InsideTopRight: 'inside-top-right',
  InsideTopLeft: 'inside-top-left',
  InsideLeftCenter: 'inside-left-center',
  InsideRightCenter: 'inside-right-center'
};
const getAnchorElement = anchorEl => {
  if (!(0, _ark.isDefined)(anchorEl)) return document.body;
  if ((0, _ark.isString)(anchorEl)) {
    const element = document.getElementById(anchorEl);
    return element ?? document.body;
  }
  if (! /*#__PURE__*/_react.default.isValidElement(anchorEl)) {
    const ref = anchorEl;
    if ((0, _ark.isObjectLike)(ref) && (0, _ark.hasProperty)(ref, 'current')) return ref.current ?? document.body;
    return document.body;
  }
  return anchorEl;
};
function getContentPosition(position, container, content) {
  let left = 0;
  let top = 0;
  const containerRect = container.getBoundingClientRect();
  const contentRect = content.getBoundingClientRect();
  switch (position) {
    case PopoverPosition.Center:
      left = containerRect.left + containerRect.width / 2 - contentRect.width / 2;
      top = containerRect.top + containerRect.height / 2 - contentRect.height / 2;
      break;
    case PopoverPosition.BottomLeft:
      left = containerRect.left;
      top = containerRect.bottom;
      break;
    case PopoverPosition.BottomRight:
      left = containerRect.left - contentRect.width + containerRect.width;
      top = containerRect.bottom;
      break;
    case PopoverPosition.BottomCenter:
      left = containerRect.left + containerRect.width / 2 - contentRect.width / 2;
      top = containerRect.bottom;
      break;
    case PopoverPosition.TopLeft:
      left = containerRect.left;
      top = containerRect.top - contentRect.height;
      break;
    case PopoverPosition.TopRight:
      left = containerRect.left - contentRect.width + containerRect.width;
      top = containerRect.top - contentRect.height;
      break;
    case PopoverPosition.TopCenter:
      left = containerRect.left + containerRect.width / 2 - contentRect.width / 2;
      top = containerRect.top - contentRect.height;
      break;
    case PopoverPosition.LeftTop:
      left = containerRect.left - contentRect.width;
      top = containerRect.top;
      break;
    case PopoverPosition.LeftBottom:
      left = containerRect.left - contentRect.width;
      top = containerRect.bottom - contentRect.height;
      break;
    case PopoverPosition.LeftCenter:
      left = containerRect.left - contentRect.width;
      top = containerRect.top + containerRect.height / 2 - contentRect.height / 2;
      break;
    case PopoverPosition.RightTop:
      left = containerRect.right;
      top = containerRect.top;
      break;
    case PopoverPosition.RightBottom:
      left = containerRect.right;
      top = containerRect.bottom - contentRect.height;
      break;
    case PopoverPosition.RightCenter:
      left = containerRect.right;
      top = containerRect.top + containerRect.height / 2 - contentRect.height / 2;
      break;
    case PopoverPosition.InsideBottomLeft:
      left = containerRect.left;
      top = containerRect.bottom - contentRect.height;
      break;
    case PopoverPosition.InsideBottomRight:
      left = containerRect.right - contentRect.width;
      top = containerRect.bottom - contentRect.height;
      break;
    case PopoverPosition.InsideBottomCenter:
      left = containerRect.left + containerRect.width / 2 - contentRect.width / 2;
      top = containerRect.bottom - contentRect.height;
      break;
    case PopoverPosition.InsideTopLeft:
      left = containerRect.left;
      top = containerRect.top;
      break;
    case PopoverPosition.InsideTopRight:
      left = containerRect.right - contentRect.width;
      top = containerRect.top;
      break;
    case PopoverPosition.InsideTopCenter:
      left = containerRect.left + containerRect.width / 2 - contentRect.width / 2;
      top = containerRect.top;
      break;
    case PopoverPosition.InsideLeftCenter:
      left = containerRect.left;
      top = containerRect.top + containerRect.height / 2 - contentRect.height / 2;
      break;
    case PopoverPosition.InsideRightCenter:
      left = containerRect.right - contentRect.width;
      top = containerRect.top + containerRect.height / 2 - contentRect.height / 2;
      break;
  }
  return {
    left,
    top
  };
}
function fixPositionInRect(rect, content, left, top, flexible) {
  if (!(0, _ark.isDefined)(rect)) return null;
  if (!(0, _ark.isDefined)(content)) return null;
  const contentRect = content.getBoundingClientRect();
  const newCoord = {
    left,
    top,
    height: 0,
    width: 0
  };
  if (left < rect.left) {
    newCoord.left = rect.left;
  }
  if (top < rect.top) {
    newCoord.top = rect.top;
  }
  if (!flexible) {
    if (left + contentRect.width >= rect.left + rect.width) {
      newCoord.left = rect.left + rect.width - contentRect.width;
    }
    if (top + contentRect.height >= rect.top + rect.height) {
      newCoord.top = rect.top + rect.height - contentRect.height;
    }
  } else {
    newCoord.width = rect.left + rect.width - left;
    newCoord.height = rect.top + rect.height - top;
  }
  return newCoord;
}
const Popover = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    id,
    className,
    backdrop,
    children,
    centered,
    overflow,
    flexible,
    anchorEl,
    position,
    style,
    onClickOutside
  } = _ref;
  const popoverRef = _react.default.useRef(null);
  const [anchorElNode, setAnchorElNode] = _react.default.useState(null);
  const [documentDimensions, setDimensions] = _react.default.useState({
    left: 0,
    top: 0,
    height: window.innerHeight,
    width: window.innerWidth
  });
  const [positionStyle, setPositionStyle] = _react.default.useState({
    position: 'fixed',
    opacity: 0,
    left: '0',
    top: '0'
  });
  const updateContentPosition = () => {
    if (!(0, _ark.isDefined)(anchorElNode) || !(0, _ark.isDefined)(popoverRef) || !(0, _ark.isDefined)(popoverRef.current)) {
      return;
    }
    let {
      left,
      top
    } = getContentPosition(position, anchorElNode, popoverRef.current);
    let height = 0;
    let width = 0;
    if (overflow === false) {
      const fixPosition = fixPositionInRect(documentDimensions, popoverRef.current, left, top, flexible === true);
      if (fixPosition !== null) {
        left = fixPosition.left;
        top = fixPosition.top;
        height = fixPosition.height;
        width = fixPosition.width;
      }
    }
    setPositionStyle(prevState => Object.assign({}, prevState, style, {
      opacity: 1,
      left: `${left.toFixed()}px`,
      top: `${top.toFixed()}px`,
      maxHeight: height > 0 ? `${height.toFixed()}px` : undefined,
      maxWidth: width > 0 ? `${width.toFixed()}px` : undefined
    }));
  };
  _react.default.useEffect(() => {
    if (!(0, _ark.isDefined)(ref)) return;
    ref.current = popoverRef.current;
  }, [popoverRef.current, ref]);
  _react.default.useEffect(() => {
    const onDocumentMouseDown = event => {
      const {
        target
      } = event;
      if (backdrop || !(0, _ark.isDefined)(popoverRef.current)) return;
      const isOutside = !popoverRef.current.contains(target);
      if (!isOutside || !onClickOutside) return;
      onClickOutside(event);
    };
    const onDisplayWindowResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
        left: 0,
        top: 0
      });
    };
    const onDocumentScroll = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
        left: 0,
        top: 0
      });
    };
    document.addEventListener('mousedown', onDocumentMouseDown);
    window.addEventListener('resize', onDisplayWindowResize);
    window.addEventListener('scroll', onDocumentScroll);
    return () => {
      document.removeEventListener('mousedown', onDocumentMouseDown);
      window.removeEventListener('resize', onDisplayWindowResize);
      window.removeEventListener('scroll', onDocumentScroll);
    };
  }, [backdrop, onClickOutside]);
  _react.default.useEffect(() => setAnchorElNode(getAnchorElement(anchorEl)), [anchorEl]);
  _react.default.useEffect(() => {
    if (!(0, _ark.isDefined)(popoverRef) || !(0, _ark.isDefined)(popoverRef.current)) {
      return;
    }
    let observer = new MutationObserver(() => {
      updateContentPosition();
    });
    observer.observe(popoverRef.current, {
      attributes: false,
      childList: true,
      subtree: true
    });
    return () => {
      if ((0, _ark.isDefined)(observer)) {
        observer.disconnect();
      }
    };
  }, [popoverRef.current]);
  _react.default.useEffect(() => {
    updateContentPosition();
  }, [anchorElNode, position, documentDimensions, setPositionStyle, style]);
  return /*#__PURE__*/_react.default.createElement(_utils.DomContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: popoverRef,
    style: positionStyle,
    className: (0, _arkReact.concatClassName)('popover', className)
  }, children), backdrop === true && (_div || (_div = /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    className: "modalBackdrop",
    "aria-hidden": "true",
    "aria-label": "drop"
  }))));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.instanceOf(HTMLElement).isRequired, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(HTMLElement).isRequired
  }).isRequired]),
  position: _propTypes.default.oneOf(Object.values(PopoverPosition)),
  backdrop: _propTypes.default.bool,
  overflow: _propTypes.default.bool,
  flexible: _propTypes.default.bool,
  style: _propTypes.default.shape({}),
  onClickOutside: _propTypes.default.func
} : void 0;
Popover.defaultProps = {
  id: undefined,
  className: undefined,
  anchorEl: undefined,
  backdrop: false,
  children: undefined,
  centered: false,
  overflow: true,
  flexible: true,
  position: PopoverPosition.BottomLeft,
  style: undefined,
  onClickOutside: undefined
};
var _default = exports.default = Popover;